/**
 * Helper: DataLayer utilities
 * -----------------------------------------------------------------------------
 * Sends events to GA4 via GTM using `dataLayer.push(...)`.
 *
 * Usage: window.dataLayerUtils.send('event_name', { key: 'value' })
 */

function send(event, params = {}) {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...params })
}

window.dataLayerUtils = { send };

/**
 * Delegated listeners
 * ---------------------------------------------------------------------------
 */

// Wishlist button
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.card__wishlist-add');
  if (!btn) return;

  send('wishlist_add', {
    product_handle: btn.dataset.productHandle,
    product_id: btn.dataset.productId
  });
});

// Social links – fire event before navigating to external site
document.addEventListener('click', function(e) {
  var link = e.target.closest('.list-social__link, .blog-list-social__link');
  if (!link) return;

  send('social_link', { platform: link.dataset.label });
});

// Newsletter signup
document.addEventListener('submit', function(e) {
  var form = e.target.closest('.newsletter-form');
  if (!form) return;

  send('newsletter_signup');
});

// Sort order change
document.addEventListener('change', function(e) {
  var select = e.target.closest('.facet-filters__sort');
  if (!select) return;

  send('sort_by', {
    sort_option: select.value,
    sort_label: select.options[select.selectedIndex].text
  });
});

// Facet filter checkbox
document.addEventListener('change', function(e) {
  var label = e.target.closest('.facet-checkbox');
  if (!label) return;

  var input = label.querySelector('input[type="checkbox"]') || e.target;
  if (!input.checked) return;

  var textLabel = label.querySelector('.facet-checkbox__text-label');
  send('apply_filter', {
    filter_name: input.name,
    filter_value: input.value,
    filter_label: textLabel ? textLabel.textContent.trim() : input.value
  });
});

// Size guide open
document.addEventListener('click', function(e) {
  if (!e.target.closest('.size-guide-trigger')) return;

  send('size_guide_open');
});

// Product accordion open
document.addEventListener('toggle', function(e) {
  var accordion = e.target.closest('.product__accordion');
  if (!accordion || !e.target.open) return;

  var title = accordion.querySelector('.accordion__title');
  send('product_accordion_open', {
    accordion_title: title ? title.textContent.trim() : ''
  });
}, true);

// Mega menu link click
document.addEventListener('click', function(e) {
  var link = e.target.closest('.mega-menu__link');
  if (!link) return;

  send('header_navigation_click', {
    link_text: link.textContent.trim(),
    link_url: link.href
  });
});

// Header menu item click
document.addEventListener('click', function(e) {
  var link = e.target.closest('.header__menu-item');
  if (!link) return;

  send('header_navigation_click', {
    link_text: link.textContent.trim()
  });
});

// Mega menu banner click
document.addEventListener('click', function(e) {
  var banner = e.target.closest('.mega-menu__banner-wrapper');
  if (!banner) return;

  var cta = banner.querySelector('.mega-menu__banner-cta');
  send('navigation_banner_click', {
    link_text: cta ? cta.textContent.trim() : banner.href
  });
});

// Footer link click
document.addEventListener('click', function(e) {
  var link = e.target.closest('footer .list-menu__item--link');
  if (!link) return;

  send('footer_navigation_click', {
    link_text: link.textContent.trim(),
    link_url: link.href
  });
});

// Cart item remove
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.cart-drawer__remove-btn');
  if (!btn) return;

  var row = btn.closest('tr');
  var name = row ? row.querySelector('.cart-item__name') : null;

  send('remove_from_cart', {
    variant_id: btn.dataset.variantId || '',
    product_title: name ? name.textContent.trim() : ''
  });
});

// Perfect gift button click (PDP vs Cart)
var _giftContext = null;
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.perfect-gift-btn');
  if (!btn) return;

  var isCart = !!btn.closest('tr.cart-item__addons-row');
  _giftContext = isCart ? 'cart' : 'pdp';

  send(isCart ? 'cart_add_giftbox_start' : 'gift_journey_start');
});

// Perfect gift confirm
document.addEventListener('click', function(e) {
  if (!e.target.closest('.perfect-gift-confirm-btn')) return;

  send(_giftContext === 'cart' ? 'cart_add_giftbox_complete' : 'gift_journey_complete');
});

// Personalisation drawer open (PDP vs Cart)
var _personaliseContext = null;
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.personalisation-drawer__opener');
  if (!btn) return;

  var isCart = !!btn.closest('tr.cart-item__addons-row');
  _personaliseContext = isCart ? 'cart' : 'pdp';

  send(isCart ? 'cart_add_personalisation_start' : 'personalise_journey_start');
});

// Personalisation drawer confirm
document.addEventListener('click', function(e) {
  if (!e.target.closest('.personalisation-drawer__confirm')) return;

  send(_personaliseContext === 'cart' ? 'cart_add_personalisation_complete' : 'personalise_journey_complete');
});

// Search modal open
document.addEventListener('click', function(e) {
  if (!e.target.closest('.header__icon--search')) return;

  send('search_modal_opened');
});

// Predictive search suggested click

document.addEventListener('click', function(e) {
  if (!e.target.closest('.predictive-search__item--suggested')) return;

  send('predictive_search_suggestion_viewed');
});

// Collection page viewed
if (window.location.pathname.startsWith('/collections/')) {
  var collectionTitle = document.querySelector('.collection-hero__title');
  if (collectionTitle) {
    send('view_item_list', {
      collection_title: collectionTitle.textContent.trim()
    });
  }
}

// Search results page viewed
if (window.location.pathname === '/search') {
  var params = new URLSearchParams(window.location.search);
  var query = params.get('q');
  if (query) {
    send('search_results_viewed', {
      search_query: query
    });
  }
}

// Distinct PDP-view counter for "PDPs viewed before ATC" (KRAKEN-4532)
// Records a session-scoped list of product handles, adding the current one on each
// real PDP load. Keyed off the top-level pathname (handles localised roots like
// /en-gb/products/…) rather than a DOM node, so the quick-add modal — which injects
// a MainProduct- section — cannot inflate the count. ?variant= lives in the query
// string, so switching variant on one PDP does not add a new entry.
if (window.location.pathname.indexOf('/products/') !== -1) {
  try {
    var pdpMatch = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    var pdpHandle = pdpMatch && pdpMatch[1];
    if (pdpHandle) {
      var pdpViewed = JSON.parse(sessionStorage.getItem('cp:pdp_views:v1') || '[]');
      if (pdpViewed.indexOf(pdpHandle) === -1) {
        pdpViewed.push(pdpHandle);
        sessionStorage.setItem('cp:pdp_views:v1', JSON.stringify(pdpViewed));
      }
    }
  } catch (e) { /* sessionStorage unavailable (private mode / blocked) */ }
}

// Expose the distinct-PDP count so GTM (Custom-JS variable) or a Customer-events
// pixel can read it and attach `pdp_views_before_atc` when add_to_cart fires.
window.dataLayerUtils.pdpViewsBeforeAtc = function () {
  try {
    return JSON.parse(sessionStorage.getItem('cp:pdp_views:v1') || '[]').length;
  } catch (e) {
    return 0;
  }
};

// PDP feature availability -> GA4 (KRAKEN-4574 / PO feedback KRAKEN-4575)
// Emits the giftbox/personalisation flags rendered by main-product.liquid, once per
// real PDP load. Each feature is reported as its OWN explicit boolean so giftbox and
// personalisation can be filtered independently in GA4 — a giftbox-only product now
// reports personalisation_enabled: false rather than appearing to have both. Runs at
// the top-level document load only, so the quick-add modal injecting a MainProduct-
// section cannot re-fire it.
// PENDING (KRAKEN-4575): the PO wants these ON the view_item event rather than this
// standalone event. view_item is fired by Shopify's native Google channel, so landing
// them there needs a Shopify custom pixel — awaiting that decision before removing this.
if (window.location.pathname.indexOf('/products/') !== -1) {
  var pdpSection = document.querySelector('section[id^="MainProduct-"]');
  if (pdpSection) {
    send('pdp_feature_availability', {
      giftbox_enabled: pdpSection.dataset.ga4GiftboxEnabled === 'true',
      personalisation_enabled: pdpSection.dataset.ga4PersonalisationEnabled === 'true'
    });
  }
}

// Search results product card click
document.addEventListener('click', function(e) {
  if (window.location.pathname !== '/search') return;
  var card = e.target.closest('.product-card-wrapper');
  if (!card) return;

  var heading = card.querySelector('.card__heading');
  send('search_item_viewed', {
    product_title: heading ? heading.textContent.trim() : ''
  });
});

// Build Your Gift Box journey card click
document.addEventListener('click', function(e) {
  var link = e.target.closest('[data-bygb-journey-card]');
  if (!link) return;

  send('bygb_product_card_click', {
    journey_title: link.dataset.bygbJourneyTitle || link.textContent.trim(),
    journey_url: link.href,
    cta_text: link.dataset.bygbJourneyCta || '',
    source_url: window.location.href,
    source_path: window.location.pathname
  });
});

// Quick add complete
document.addEventListener('click', function(e) {
  if (!e.target.closest('quick-add-modal .product-form__submit')) return;

  send('quick_add_complete');
});

// Family set add bundle to bag
document.addEventListener('click', function(e) {
  if (!e.target.closest('.family-set__add-bundle-to-bag')) return;
  var title = document.querySelector('.product__title-heading');
  send('add_to_cart', {
    product_title: title ? title.textContent.trim() : ''
  });
});
// Cart gift box edit
document.addEventListener('click', function(e) {
  if (!e.target.closest('.cart-item__gift_box-edit-button-option')) return;
  send('cart_edit_gift_message');
});

// Cart gift box remove (capture phase – cart.js calls stopPropagation)
document.addEventListener('click', function(e) {
  if (!e.target.closest('.cart-item__gift_box-remove-button-option')) return;
  send('cart_remove_gift_box');
}, true);

// Cart personalisation edit (capture phase – cart.js calls stopPropagation)
document.addEventListener('click', function(e) {
  if (!e.target.closest('.cart-item__personalisation-edit-button-option')) return;
  send('cart_edit_personalisation');
}, true);

// Cart personalisation remove (capture phase – cart.js calls stopPropagation)
document.addEventListener('click', function(e) {
  if (!e.target.closest('.cart-item__personalisation-remove-button-option')) return;
  send('cart_remove_personalisation');
}, true);

// Cross-sell card click (title or image)
document.addEventListener('click', function(e) {
  var card = e.target.closest('.cross-sell-card');
  if (!card || (!e.target.closest('.cross-sell-card__title') && !e.target.closest('.cross-sell-card__image'))) return;
  var title = card.querySelector('.cross-sell-card__title');
  send('cart_cross_sell_click', {
    product_title: title ? title.textContent.trim() : ''
  });
});

// Cross-sell add to cart
document.addEventListener('click', function(e) {
  if (!e.target.closest('.cross-sell-quick-add__submit')) return;
  send('cart_cross_sell_add_to_cart');
});

// Homepage hero CTA click (KRAKEN-4587)
// image-banner is reused on many page templates, so gate to the homepage via the
// `index-` body-class token ({{ template.name }}-{{ template.suffix }}) and anchor on
// the hero CTA container (unique to image-banner.liquid), not the generic link classes.
document.addEventListener('click', function(e) {
  if (!document.body.classList.contains('index-')) return;
  var link = e.target.closest('.banner__box-ctas a');
  if (!link) return;

  send('hero_cta_click', {
    cta_text: link.textContent.trim(),
    cta_url: link.href
  });
});
